import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { getMediaStatsByCourseQuery } from 'modules/media/graphql/mediaStats/queries';

import { formatValue, timeString } from '@ts-core/utils/dataTableUtils';
import { useFilteredData } from '@ts-core/hooks/ui';

export default function useMediaStatsByCourse({ courseId }) {
  const intl = useIntl();

  const { loading, error, data, refetch } = useQuery(getMediaStatsByCourseQuery, {
    variables: { courseId },
    skip: !courseId,
    fetchPolicy: 'network-only',
  });
  const mediaStats = useMemo(() => data?.mediaStats || {}, [data]);

  const { mediaItems: allMediaItems, ...others } = mediaStats;
  const { filteredData: mediaItems, onFilterData: onFilterStats } = useFilteredData({
    list: allMediaItems,
    fields: ['name'],
  });

  const onGetXlsxData = useCallback(
    (sortedData) => {
      const headers = [
        intl.formatMessage({ id: 'field.name.label' }),
        intl.formatMessage({ id: 'subject' }),
        intl.formatMessage({ id: 'mediaStatsTable.duration' }),
        intl.formatMessage({ id: 'mediaStatsTable.totalViews' }),
        intl.formatMessage({ id: 'mediaStatsTable.studentsCount' }),
        intl.formatMessage({ id: 'mediaStatsTable.viewsPerStudent' }),
        intl.formatMessage({ id: 'mediaStatsTable.avgProgress' }),
        intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
      ];

      const xlsData = [headers];

      sortedData.forEach((rowData) => {
        const { _original: mediaStatsRow } = rowData;
        const mediaStatsData = [
          mediaStatsRow.name,
          mediaStatsRow.subject?.name,
          timeString(mediaStatsRow.duration),
          mediaStatsRow.totalViews,
          mediaStatsRow.studentsCount,
          formatValue(mediaStatsRow.avgViewsPerStudent, undefined, false, 2),
          formatValue(mediaStatsRow.avgProgressPercentage, 1),
          formatValue(mediaStatsRow.maxProgressPercentage, 1),
        ];
        xlsData.push(mediaStatsData);
      });

      return xlsData;
    },
    [intl]
  );

  return {
    loading,
    error: getErrorMessage({ error }),
    mediaStats: {
      ...others,
      mediaItems,
    },
    onFilterStats,
    onFetchStats: refetch,
    onGetXlsxData,
  };
}
